<template>
  <div>
    <div class="row pt-2">
      <div class="col-3">
        <div @click="showWarning" class="back-btn">
          <img src="@/assets/img/arrow_left.svg" style="display:inline-block;" alt="" />
          Back
        </div>
      </div>
      <div class="col-9">
        <div class="d-flex flex-row align-items-center selected-currency">
          <img
            :src="anyWalletCoin && anyWalletCoin.logo ? anyWalletCoin.logo : ''"
            class="currency-icon"
            :alt="anyWalletCoin.currency"
          />
          <small class="ml-2 mt-1">{{ anyWalletCoin.name }}</small>
          <div
            v-b-tooltip.hover.top="{ customClass: 'my-tooltip-class' }"
            :title="$t('payment.faster-tooltip')"
            v-if="anyWalletCoin.fasterConfirmation"
            class="lightning-icon">
            <img src="@/assets/img/lightning.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="mt-2" v-if="!isPreview">
      <CryptoWalletsQR
        :qrData="qrData"
        :payableData="payableData"
        :currencies="currencies"
        :anyWalletCoin="anyWalletCoin"
        :isCodeExpired="isCodeExpired"
        :anyWalletError="anyWalletError"
        :convertedCart="convertedCart"
        :displayCurrency="displayCurrency"
        :isPreview="isPreview"
        :isContinuedTransaction="isContinuedTransaction"
      />
    </div>
    <div class="tab-data__wrapper">
      <div class="d-flex flex-nowrap align-content-center align-items-center">
        <div class="p-2 flex-grow-1 mt-2">
          <div class="blockchain-steps-list">
            <div 
              v-for="(step, i) in blockchainSteps" 
              :key="i" 
              class="blockchain-step-item"
              :class="{ 
                'step-completed': step.icon && step.icon.includes('done.svg'),
                'step-active': step.icon && step.icon.includes('spinner.gif')
              }"
            >
              <div class="step-icon-container">
                <img :src="step.icon" class="step-icon" alt="step-icon" />
                <div 
                  class="step-connector-line" 
                  v-if="i < blockchainSteps.length - 1"
                  :class="{ 
                    'line-completed': blockchainSteps[i+1] && blockchainSteps[i+1].icon && blockchainSteps[i+1].icon.includes('done.svg')
                  }"
                ></div>
              </div>
              <span class="step-label">{{step.label}}</span>
            </div>
          </div>
        </div>
        <!-- <div
          v-if="
            anyWalletCoin.currency
              && metaMaskCoins.indexOf(anyWalletCoin.currency) !== -1
          "
          class="metaMask p-2"
        >
          <div class="metaMask-pay mb-2">
            {{ $t("unauth-payment.pay-using") }}
          </div>
          <div>
    
          </div>
        </div> -->
      </div>
    </div>
    <PopupModal
      :title="$t('warning-modal.title')"
      id="1"
      :showModal="warningModal"
      :description="warningMsg"
      :cancel="$t('warning-modal.cancel')"
      :extraWarning="$t('warning-modal.extra-warning')"
      :dismiss="$t('warning-modal.dismiss')"
      @cancelClicked="backToPreviousStep"
      @dismissClicked="warningModal = false"
    />
  </div>
</template>
<script>
/* eslint-disable */

import PopupModal from '@/components/PopupModal.vue';
import CryptoWalletsQR from "@/components/CryptoWalletsQR.vue";
import { META_MASK_COINS, USER_TRACK_EVENTS } from '@/store/modules/user/consts';
import { mapGetters } from 'vuex';

export default {
  name: "SecondStep",
  data() {
    return {
      selectedCurrency: "",
      warningModal: false,
      metaMaskCoins: META_MASK_COINS,
    };
  },
  components: {
    CryptoWalletsQR,
    PopupModal
  },
  props: [
    "anyWalletCoin",
    "anyWalletError",
    "qrData",
    "payableData",
    "currencies",
    "convertedCart",
    "displayCurrency",
    "isPreview",
    "isCodeExpired",
    "isContinuedTransaction"
  ],
  computed: {
    ...mapGetters({
      paymentCompleted: 'auth/paymentCompleted',
    }),
    warningMsg() {
      let msg = this.$t('warning-modal.description')
      let walletName = this.anyWalletCoin && this.anyWalletCoin.name ? this.anyWalletCoin.name : 'crypto';
      msg = msg.replace('[crypto]', ` ${walletName}`);

      return msg;
    },
    blockchainSteps() {
      let stepOneIcon = this.qrData.id ? require('@/assets/img/done.svg') : require('@/assets/img/spinner.gif')
      let stepTwoIcon = require('@/assets/img/circle.png');
      let stepThreeIcon = require('@/assets/img/circle.png');
      const isFasterCoin = this.anyWalletCoin?.fasterConfirmation;

      if(this.paymentCompleted) {
        stepTwoIcon = require('@/assets/img/done.svg');
        // Only make step 3 active for faster coins
        if (isFasterCoin) {
          stepThreeIcon = require('@/assets/img/spinner.gif');
          setTimeout(() => {
            stepThreeIcon = require('@/assets/img/done.svg');
          }, 200);
        }
        // For non-faster coins, stepThreeIcon remains circle.png (inactive)
      } else if(this.qrData.id) {
        stepTwoIcon = require('@/assets/img/spinner.gif');
      }

      let steps = [
        {
          icon: stepOneIcon,
          label: "QR Code Generated"
        },
        {
          icon: stepTwoIcon,
          label: "Transaction Detected"
        }
      ];

      // Always show Payment Complete step, but only activate it for faster coins
      steps.push({
        icon: stepThreeIcon,
        label: "Payment Complete"
      });

      return steps;
    }
  },
  methods: {
    showWarning() {
      this.warningModal = true;
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: 'Qr payments',
          activity: `clicked on back button, change currency confirmation required`,
        },
      });
    },
    backToPreviousStep() {
      this.$emit(`backToPreviousStep`);
    },
  }
};
</script>
<style lang="scss" scoped>
.footer-btn {
  padding: 0px 10px;
  cursor: pointer;
  border-radius: 5px;
  color: #5559fe;
  margin: 0px 5px;
  border: 1px solid #5559fe;
}

.footer-btn:nth-child(2) {
  background: #5559fe;
  color: white;
}

.footer-btn:nth-child(1) {
  background: white;
  color: black;
}

.back-btn {
  cursor: pointer;
  margin-top:5px;
}

.selected-currency {
  float:right;

  .currency-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
}
.chainNetwork{
  text-transform: capitalize !important;
}

.blockchain-steps-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.blockchain-step-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 2px 0;
  min-height: 20px;
}

.step-icon-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 20px;
  flex-shrink: 0;
  padding-top: 0;
}

.step-icon {
  width: 20px;
  height: 20px;
  z-index: 1;
  position: relative;
  display: block;
}

.step-connector-line {
  width: 2px;
  height: 12px;
  background-color: #e0e0e0;
  margin-top: 2px;
  transition: background-color 0.3s ease;
}

.step-label {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  transition: color 0.3s ease;
  line-height: 20px;
  margin-top: 0;
  padding-top: 0;
}

.step-connector-line.line-completed {
  background-color: #4caf50;
}

.blockchain-step-item.step-completed .step-label {
  color: #4caf50;
}

.blockchain-step-item.step-active .step-label {
  color: #5559fe;
}
</style>
